import { Chart } from 'chart.js';

const PALETTE = [
  '#2563eb', '#7c3aed', '#0ea5e9', '#10b981', '#f59e0b',
  '#ec4899', '#14b8a6', '#f43f5e', '#8b5cf6', '#06b6d4',
];

const fmtEuro = (cents) =>
  '\u20AC ' + (cents / 100).toLocaleString('nl-BE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export function prijzengeldCharts(config) {
  return {
    charts: {},
    _observer: null,

    init() {
      this.$nextTick(() => this.renderAll());
      this._observer = new MutationObserver(() => this.retheme());
      this._observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    },

    destroy() {
      this._observer?.disconnect();
      Object.values(this.charts).forEach((c) => c?.destroy());
    },

    theme() {
      const dark = document.documentElement.classList.contains('dark');
      return {
        text: dark ? '#9ca3af' : '#6b7280',
        grid: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
        tooltipBg: dark ? '#1f2937' : '#111827',
      };
    },

    retheme() {
      Object.values(this.charts).forEach((c) => c?.destroy());
      this.charts = {};
      this.renderAll();
    },

    renderAll() {
      const t = this.theme();
      this.renderSeizoenBar('seizoen-totaal-chart', config.perSeizoen, t);
      if (config.trendRenners?.renners?.length) {
        this.renderTrend('seizoen-trend-chart', config.trendRenners, t);
      }
    },

    renderSeizoenBar(canvasId, data, t) {
      const el = document.getElementById(canvasId);
      if (!el || !data?.length) return;
      this.charts[canvasId] = new Chart(el, {
        type: 'bar',
        data: {
          labels: data.map((d) => d.label),
          datasets: [{
            label: 'Totaal',
            data: data.map((d) => parseInt(d.totaal_cents)),
            backgroundColor: '#2563eb',
            borderRadius: 4,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              ticks: { color: t.text },
              grid: { display: false },
            },
            y: {
              ticks: {
                color: t.text,
                callback: (v) => '\u20AC ' + (v / 100).toLocaleString('nl-BE'),
              },
              grid: { color: t.grid },
            },
          },
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: t.tooltipBg,
              callbacks: {
                label: (ctx) => ` ${fmtEuro(ctx.raw)}`,
              },
            },
          },
        },
      });
    },

    renderTrend(canvasId, data, t) {
      const el = document.getElementById(canvasId);
      if (!el) return;
      const datasets = data.renners.map((r, i) => ({
        label: r.naam,
        data: r.data,
        borderColor: PALETTE[i % PALETTE.length],
        backgroundColor: PALETTE[i % PALETTE.length] + '18',
        fill: false,
        tension: 0.3,
        pointRadius: 4,
        pointHoverRadius: 6,
      }));
      this.charts[canvasId] = new Chart(el, {
        type: 'line',
        data: {
          labels: data.seizoenen,
          datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: 'index', intersect: false },
          scales: {
            x: {
              ticks: { color: t.text },
              grid: { display: false },
            },
            y: {
              ticks: {
                color: t.text,
                callback: (v) => '\u20AC ' + (v / 100).toLocaleString('nl-BE'),
              },
              grid: { color: t.grid },
            },
          },
          plugins: {
            legend: {
              labels: { color: t.text, usePointStyle: true, pointStyle: 'circle' },
            },
            tooltip: {
              backgroundColor: t.tooltipBg,
              callbacks: {
                label: (ctx) => ` ${ctx.dataset.label}: ${fmtEuro(ctx.raw)}`,
              },
            },
          },
        },
      });
    },
  };
}
